/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const reportsExcludeFilterMap = {
  excludeReportStatuses: "reportStatuses",
  excludeReportTypes: "reportTypes",
  excludeCreatedBy: "createdBy",
} as const;

export const eventsExcludeFilterMap = {
  excludeEventStatuses: "eventStatuses",
  excludeEventRelatedPlanIds: "eventRelatedPlanIds",
  excludeEventActionIds: "eventActionIds",
  excludeEventLogOutputs: "eventLogOutputs",
} as const;

export const plansExcludeFilterMap = {
  excludePlanStatuses: "planStatuses",
  excludePlanActionIds: "planActionIds",
  excludeScheduleOptions: "scheduleOptions",
} as const;

export const accountsExcludeFilterMap = {
  excludeCloudProviders: "cloudProviders",
  excludeCloudAccountStatuses: "cloudAccountStatuses",
} as const;

export const customActionsExcludeFilterMap = {
  excludeTypes: "types",
  excludeScopes: "scopes",
  excludePlanIds: "planIds",
} as const;

export const resourcesExcludeFilterMap = {
  excludeCloudProviders: "cloudProviders",
  excludeOperatingSystems: "operatingSystems",
  excludeRegions: "regions",
  excludeResourceTagKeysAndTagValues: "resourceTagKeysAndTagValues",
  excludeCloudAccounts: "cloudAccounts",
  excludeResourceGroups: "resourceGroups",
  excludePlans: "plans",
  excludeResourcePingStatuses: "resourcePingStatuses",
  excludeLastUpdateStatuses: "lastUpdateStatuses",
} as const;

export const resourceDetailsResourceGroupsExcludeFilterMap = {
  excludeCreatedBy: "createdBy",
} as const;

export const resourceGroupsExcludeFilterMap = {
  excludeTypes: "types",
} as const;

export const resourceDetailsActionsExcludeFilterMap = {
  excludeResourceStatuses: "resourceStatuses",
  excludeActionNames: "actionNames",
  excludeActionTypes: "actionTypes",
  excludeActionLogOutputs: "actionLogOutputs",
} as const;
